import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Briefs = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 28 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M2.45 3.99173C2.45 3.04449 3.43055 2.41527 4.29165 2.80995L10.7916 5.78911C11.2537 6.0009 11.55 6.46259 11.55 6.9709V18.3208C11.55 19.268 10.5695 19.8972 9.70835 19.5026L3.20835 16.5234L2.91669 17.1597L3.20835 16.5234C2.74626 16.3116 2.45 15.8499 2.45 15.3416V3.99173Z"
        fill="white"
        stroke={color}
        strokeWidth="1.4"
      />
      <path
        d="M6.825 9.24173C6.825 8.29449 7.80555 7.66527 8.66665 8.05995L15.1666 11.0391C15.6287 11.2509 15.925 11.7126 15.925 12.2209V23.5708C15.925 24.518 14.9445 25.1472 14.0833 24.7526L7.58335 21.7734L7.29169 22.4097L7.58335 21.7734C7.12126 21.5616 6.825 21.0999 6.825 20.5916V9.24173Z"
        fill="white"
        stroke={color}
        strokeWidth="1.4"
      />
      <path
        d="M11.2 3.99173C11.2 3.04449 12.1805 2.41527 13.0417 2.80995L19.5416 5.78911C20.0037 6.0009 20.3 6.46259 20.3 6.9709V18.3208C20.3 19.268 19.3195 19.8972 18.4583 19.5026L11.9584 16.5234L11.6667 17.1597L11.9583 16.5234C11.4963 16.3116 11.2 15.8499 11.2 15.3416V3.99173Z"
        fill="white"
        stroke={color}
        strokeWidth="1.4"
      />
      <path
        d="M15.575 9.24173C15.575 8.29449 16.5555 7.66527 17.4167 8.05995L23.9166 11.0391C24.3787 11.2509 24.675 11.7126 24.675 12.2209V23.5708C24.675 24.518 23.6945 25.1472 22.8333 24.7526L16.3334 21.7734L16.0417 22.4097L16.3333 21.7734C15.8713 21.5616 15.575 21.0999 15.575 20.5916V9.24173Z"
        fill="white"
        stroke={color}
        strokeWidth="1.4"
      />
      <path d="M19.25 12.25L22.3125 13.5625" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
      <path d="M19.25 14.875L22.3125 16.1875" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
      <path d="M10.5 19.25L13.5625 20.5625" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
      <path d="M19.25 17.5L21 18.375" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
      <path
        d="M18.1124 11.6375C18.1124 11.9758 17.8382 12.25 17.4999 12.25C17.1616 12.25 16.8874 11.9758 16.8874 11.6375C16.8874 11.2992 17.1616 11.025 17.4999 11.025C17.8382 11.025 18.1124 11.2992 18.1124 11.6375Z"
        fill={color}
      />
      <path
        d="M14.1759 6.29995C14.1759 6.63823 13.9017 6.91245 13.5634 6.91245C13.2251 6.91245 12.9509 6.63823 12.9509 6.29995C12.9509 5.96168 13.2251 5.68745 13.5634 5.68745C13.9017 5.68745 14.1759 5.96168 14.1759 6.29995Z"
        fill={color}
      />
      <path
        d="M14.1757 9.01245C14.1757 9.35073 13.9015 9.62495 13.5632 9.62495C13.2249 9.62495 12.9507 9.35073 12.9507 9.01245C12.9507 8.67418 13.2249 8.39995 13.5632 8.39995C13.9015 8.39995 14.1757 8.67418 14.1757 9.01245Z"
        fill={color}
      />
      <path
        d="M14.1751 11.8125C14.1751 12.1507 13.9009 12.425 13.5626 12.425C13.2243 12.425 12.9501 12.1507 12.9501 11.8125C12.9501 11.4742 13.2243 11.2 13.5626 11.2C13.9009 11.2 14.1751 11.4742 14.1751 11.8125Z"
        fill={color}
      />
      <path
        d="M9.53739 18.8125C9.53739 19.1507 9.26317 19.425 8.92489 19.425C8.58662 19.425 8.31239 19.1507 8.31239 18.8125C8.31239 18.4742 8.58662 18.2 8.92489 18.2C9.26317 18.2 9.53739 18.4742 9.53739 18.8125Z"
        fill={color}
      />
      <path
        d="M9.53739 16.3625C9.53739 16.7007 9.26317 16.975 8.92489 16.975C8.58662 16.975 8.31239 16.7007 8.31239 16.3625C8.31239 16.0242 8.58662 15.75 8.92489 15.75C9.26317 15.75 9.53739 16.0242 9.53739 16.3625Z"
        fill={color}
      />
      <path
        d="M9.53739 13.825C9.53739 14.1632 9.26317 14.4375 8.92489 14.4375C8.58662 14.4375 8.31239 14.1632 8.31239 13.825C8.31239 13.4867 8.58662 13.2125 8.92489 13.2125C9.26317 13.2125 9.53739 13.4867 9.53739 13.825Z"
        fill={color}
      />
      <path
        d="M9.53739 11.1125C9.53739 11.4507 9.26317 11.725 8.92489 11.725C8.58662 11.725 8.31239 11.4507 8.31239 11.1125C8.31239 10.7742 8.58662 10.5 8.92489 10.5C9.26317 10.5 9.53739 10.7742 9.53739 11.1125Z"
        fill={color}
      />
      <path
        d="M5.1625 5.86245C5.1625 6.20073 4.88827 6.47495 4.55 6.47495C4.21173 6.47495 3.9375 6.20073 3.9375 5.86245C3.9375 5.52418 4.21173 5.24995 4.55 5.24995C4.88827 5.24995 5.1625 5.52418 5.1625 5.86245Z"
        fill={color}
      />
      <path
        d="M5.1625 8.39995C5.1625 8.73823 4.88827 9.01245 4.55 9.01245C4.21173 9.01245 3.9375 8.73823 3.9375 8.39995C3.9375 8.06168 4.21173 7.78745 4.55 7.78745C4.88827 7.78745 5.1625 8.06168 5.1625 8.39995Z"
        fill={color}
      />
      <path
        d="M5.1625 10.7625C5.1625 11.1007 4.88827 11.375 4.55 11.375C4.21173 11.375 3.9375 11.1007 3.9375 10.7625C3.9375 10.4242 4.21173 10.15 4.55 10.15C4.88827 10.15 5.1625 10.4242 5.1625 10.7625Z"
        fill={color}
      />
      <path
        d="M18.1128 14.2625C18.1128 14.6007 17.8386 14.875 17.5003 14.875C17.162 14.875 16.8878 14.6007 16.8878 14.2625C16.8878 13.9242 17.162 13.65 17.5003 13.65C17.8386 13.65 18.1128 13.9242 18.1128 14.2625Z"
        fill={color}
      />
      <path
        d="M18.1124 16.8875C18.1124 17.2258 17.8382 17.5 17.4999 17.5C17.1616 17.5 16.8874 17.2258 16.8874 16.8875C16.8874 16.5492 17.1616 16.275 17.4999 16.275C17.8382 16.275 18.1124 16.5492 18.1124 16.8875Z"
        fill={color}
      />
    </svg>
  )
})

export default Briefs
